<div class="selected" (click)="open = !open">
	<ng-container *ngIf="!!units && selected != null && selected >= 0 && selected < units.all.length">
		<b>{{units.all[selected].dim}}: {{units.all[selected].area|number:'0.0-2':'en-ZA'}}m²</b>
		 | {{units.all[selected].desc}}
	</ng-container>
</div>
<ul class="options" [ngClass]="{open: open}">
	<ng-container *ngFor="let size of ['small', 'medium', 'large', 'parking']">
		<li class="group" *ngIf="units.by_size[size].length > 0">
			<p><span>{{size | titlecase}} {{size == 'parking' ? 'bays' : 'units'}}</span></p>
			<ul>
				<li *ngFor="let unit of units.by_size[size]; let i = index" (click)="select(size, i)" [ngClass]="{active: selected == unit.index, unlocked: unit.unlocked}">
					{{unit.dim}}: {{unit.area|number:'0.0-2':'en-ZA'}}m²<span> | {{unit.desc}}</span>
					<span *ngIf="unit.first_month_free || unit.one_month_half_price || unit.three_month_half_price" class="special">&#9733;</span>
				</li>
			</ul>
		</li>
	</ng-container>
</ul>
